module.exports = require("plugin-mantine-resources/shared/mantineProvider");